/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-empty */
/* eslint-disable jsx-a11y/media-has-caption */
import {
  Add,
  ArrowLeft2,
  ArrowRight2,
  Heart,
  Pause,
  Play,
  Send2,
  VolumeHigh,
  VolumeSlash,
} from 'iconsax-react';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams, useSearchParams } from 'react-router-dom';
import Text from '../../assets/styles/Text';
import MediaUploadsService from '../../services/MediaUploadsService';
import ModelService from '../../services/ModelService';
import { useStore } from '../../stores';
import preloadVerification from '../../utils/preloadVerification';
import Loader from '../Loader';
import ReactPortal from '../ReactPortal';
import * as styles from './styles';

export default function Midia({ midia, show, icon, onClose, total }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [loading, setLoading] = useState(true);
  const [model, setModel] = useState('');
  const [photo, setPhoto] = useState('');
  const [likesCount, setLikesCount] = useState(midia?.likesCount || 0);
  const [isLiked, setIsLiked] = useState(false);

  const videoRef = useRef(null);
  const { user } = useStore();
  const { id } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();
  const mediaIndex = parseInt(searchParams.get('media'), 10);

  useEffect(() => {
    async function loadVerification() {
      try {
        setLoading(true);

        if (!id) {
          setLoading(false);
          return;
        }

        const findModel = await ModelService.findById(id);
        const { urls } = await MediaUploadsService.listVerification(id);

        setModel(findModel);
        setPhoto(urls.profilePhoto);

        await preloadVerification([urls.profilePhoto]);
      } catch (error) {
        console.log(error);
        console.error('Erro ao carregar verificação:', error);
      } finally {
        setLoading(false);
      }
    }

    loadVerification();
  }, [id]);

  useEffect(() => {
    if (midia) {
      setLikesCount(midia.likesCount || 0);
      setIsLiked(
        midia.likes?.some((like) => like.clientId === user?.id) || false
      );
    }
  }, [midia, user?.id]);

  function handleNext() {
    const next = (mediaIndex + 1) % total;
    const newParams = new URLSearchParams(window.location.search);
    newParams.set('media', next);
    setSearchParams(newParams);
  }

  function handlePrev() {
    const prev = (mediaIndex - 1 + total) % total;
    const newParams = new URLSearchParams(window.location.search);
    newParams.set('media', prev);
    setSearchParams(newParams);
  }

  function togglePlay() {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  }

  function toggleMute() {
    const video = videoRef.current;
    if (!video) return;

    video.muted = !video.muted;
    setIsMuted(video.muted);
  }

  async function toggleLike(mediaId) {
    if (!user) {
      toast.error('Você precisa estar logado para curtir!');
      return;
    }

    if (user.type !== 'client') {
      toast.error('Apenas clientes podem curtir!');
      return;
    }

    try {
      // Fazer a requisição para o backend
      const response = await MediaUploadsService.toggleLike(mediaId);

      // Atualizar o estado local baseado na resposta
      if (response.liked) {
        setIsLiked(true);
        setLikesCount((prev) => prev + 1);
        toast.success('Curtido!');
      } else {
        setIsLiked(false);
        setLikesCount((prev) => prev - 1);
        toast.success('Curtida removida!');
      }
    } catch (error) {
      console.log(error);
      toast.error('Erro ao curtir. Tente novamente!');
    }
  }

  const isImage = midia?.mediaType === 'photo';

  if (!show) return null;
  if (!midia) return <Loader isLoading={loading} />;

  return (
    <ReactPortal containerId="midia" onClick={onClose}>
      <styles.Modal onClick={onClose}>
        <styles.ButtonClose
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <Add />
        </styles.ButtonClose>

        <styles.Container onClick={(e) => e.stopPropagation()}>
          {icon && model && (
            <styles.Header>
              <styles.ProfileImg className="watermark" $profile={photo}>
                <Loader isLoading={loading} minimal size={40} />
              </styles.ProfileImg>

              <Text.H4 $bold>{model?.fantasyName}</Text.H4>
            </styles.Header>
          )}

          <styles.GroupImg>
            {icon && total > 1 && (
              <button type="button" className="left" onClick={handlePrev}>
                <ArrowLeft2 />
              </button>
            )}

            {isImage ? (
              <styles.WrapMidia>
                <img src={midia?.url} alt="Imagem" />
              </styles.WrapMidia>
            ) : (
              <styles.WrapMidia>
                <video
                  ref={videoRef}
                  src={midia?.url}
                  playsInline
                  muted={isMuted}
                  onClick={togglePlay}
                  onEnded={() => setIsPlaying(false)}
                />
                <styles.Controls>
                  <button type="button" onClick={togglePlay}>
                    {isPlaying ? <Pause /> : <Play />}
                  </button>

                  <button type="button" onClick={toggleMute}>
                    {isMuted ? <VolumeSlash /> : <VolumeHigh />}
                  </button>
                </styles.Controls>
              </styles.WrapMidia>
            )}

            {icon && total > 1 && (
              <button type="button" className="right" onClick={handleNext}>
                <ArrowRight2 />
              </button>
            )}
          </styles.GroupImg>

          {icon && midia?.id && (
            <styles.BottomButtons>
              <Text.P>
                <b>Curtidas: {likesCount}</b>
              </Text.P>

              <styles.Button
                type="button"
                onClick={() => toggleLike(midia?.id)}
                $active={isLiked}
              >
                <Heart variant="Bold" />
                <Text.Span>{isLiked ? 'Curtido' : 'Curtir'}</Text.Span>
              </styles.Button>

              <styles.Button
                type="button"
                onClick={() => {
                  navigator.clipboard
                    .writeText(window.location.href)
                    .then(() => {
                      toast.success('URL copiada!');
                    })
                    .catch((err) => {
                      toast.error('Erro ao copiar:', err);
                    });
                }}
              >
                <Send2 variant="Bold" />
              </styles.Button>
            </styles.BottomButtons>
          )}
        </styles.Container>
      </styles.Modal>
    </ReactPortal>
  );
}

Midia.propTypes = {
  midia: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  icon: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  total: PropTypes.number,
};
